<!-- Step 2/3 — what the app is for. Scrolls between a fixed header and a
     fixed footer so the primary action never leaves the screen. -->
<main class="onb onb--sheet">

  <header class="onb__topbar onb__topbar--split">
    <button class="onb__circle" type="button" data-id="back" aria-label="<%= _lcs( 'Zurück' ) %>">
      <i class="icon icon--arrow-left"></i>
    </button>
    <button class="onb__plain onb__plain--muted" type="button" data-id="skip"><%= _lcs( 'Überspringen' ) %></button>
  </header>

  <div class="onb__scroll">
    <p class="belturo-eyebrow onb__eyebrow"><%= _lcs( 'Was dich erwartet' ) %></p>
    <h1 class="onb__title"><%= _lcs( 'Deine Region,' ) %> <em><%= _lcs( 'entdeckt.' ) %></em></h1>

    <ul class="onb-benefits">
      <% benefits.forEach( function( b ) { %>
      <li class="onb-benefit">
        <span class="onb-benefit__icon"><i class="icon icon--<%= b.icon %>"></i></span>
        <div class="onb-benefit__body">
          <p class="onb-benefit__title"><%= _lcs( b.title ) %></p>
          <p class="onb-benefit__text"><%= _lcs( b.text ) %></p>
        </div>
      </li>
      <% } ); %>
    </ul>

    <p class="onb-note">
      <i class="icon icon--qr-code"></i>
      <span><%= _lcs( 'Kein Download nötig — die App lebt in deinem Browser.' ) %></span>
    </p>
  </div>

  <footer class="onb__foot onb__foot--bordered">
    <div class="onb-progress" data-id="progress"></div>
    <button class="btn btn--primary btn--lg btn--block" type="button" data-id="next">
      <%= _lcs( 'Weiter' ) %> <i class="icon icon--arrow-right"></i>
    </button>
  </footer>

</main>
